import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initSplide();
  }

  initSplide() {
    const splideElement = this.element.querySelector('.logo-slider');
    
    if (splideElement) {
      const splide = new Splide('.logo-slider', {
        perPage: 3,
        type: 'loop',
        pagination: false,
        speed: 860,
        arrows: false,
        lazyLoad: 'nearby',
        drag: 'free',
        focus: 'center',
        autoScroll: {
          speed: 0.75,
          pauseOnHover: false,
        },
        mediaQuery: 'min',
        breakpoints: {
          700: {
            perPage: 4,
          },
          1024: {
            perPage: 5,
          },
          1280: {
            perPage: 6,
            autoScroll: {
              speed: 1,
            },
          },
        }
      });

      splide.on('ready', function() {
        splideElement.classList.add('is-active');
      });

      splide.mount(window.splide.Extensions);
    }
  }
} 